










import Vue from 'vue'
import PaperAirplane from './icons/PaperAirplane.vue'
import UserGroup from './icons/UserGroup.vue'
import ChevronDown from './icons/ChevronDown.vue'
import Reply from './icons/Reply.vue'
import DotsVertical from './icons/DotsVertical.vue'
import GlobeAlt from './icons/GlobeAlt.vue'
import LockClosed from './icons/LockClosed.vue'
import User from './icons/User.vue'
import CheckCircle from './icons/CheckCircle.vue'
import XCircle from './icons/XCircle.vue'
import Document from './icons/Document.vue'
import Download from './icons/Download.vue'
import Correct from './icons/Correct.vue'
import NextArrow from './icons/NextArrow.vue'
import PreviousArrow from './icons/PreviousArrow.vue'
import Cross from './icons/Cross.vue'
import Comment from './icons/Comment.vue'
import Files from './icons/Files.vue'
import Bulb from './icons/Bulb.vue'
import Trash from './icons/Trash.vue'
import Assessments from './icons/Assessments.vue'
import Copy from './icons/Copy.vue'
import Install from './icons/Install.vue'

const icons = {
    paperairplane: PaperAirplane,
    usergroup: UserGroup,
    chevrondown: ChevronDown,
    reply: Reply,
    dotsvertical: DotsVertical,
    globealt: GlobeAlt,
    lockclosed: LockClosed,
    user: User,
    checkcircle: CheckCircle,
    xcircle : XCircle,
    document: Document,
    download: Download,
    correct: Correct,
    previousarrow: PreviousArrow,
    nextarrow: NextArrow,
    cross: Cross,
    comment: Comment,
    files: Files,
    bulb: Bulb,
    trash: Trash,
    assessments: Assessments,
    copy: Copy,
    install: Install
}
export default Vue.extend({
  name: 'BaseIcon',
  props: {
    hwClass: {
      type: String,
      default: 'h-5 w-5'
    },
    name: {
      type: String,
      required: true,
      validator(value) {
        return Object.prototype.hasOwnProperty.call(icons, value)
      }
    },
  },

  computed: {
    iconComponent() {
      return icons[this.name]
    },

    getHwClass() {
      return this.hwClass
    }
  }
})
